function alignmentValidator(alignment) {
  return ['top', 'bottom'].includes(alignment);
}

export var props = {
  show: {
    type: Boolean,
    default: false
  },
  alignment: {
    type: String,
    default: 'top',
    validator: alignmentValidator
  },
  offsetX: {
    type: [Number, String],
    default: 0
  },
  offsetY: {
    type: [Number, String],
    default: 0
  },
  teleport: {
    type: String,
    default: 'body'
  },
  onOpen: {
    type: Function
  },
  onOpened: {
    type: Function
  },
  onClose: {
    type: Function
  },
  onClosed: {
    type: Function
  },
  'onUpdate:show': {
    type: Function
  }
};